import type {
  NamedScriptInfo,
  NamedScriptLoadOptions,
  NamedScriptStrategy,
} from "./namedScriptLoad";
import { observeNamedScript } from "./namedScriptLoad";

export type AppMainScriptStrategy = NamedScriptStrategy;
export type AppMainScriptInfo = NamedScriptInfo;
export type AppMainScriptLoadOptions = NamedScriptLoadOptions;

// Matches app.js, main.js, app.abc123.js, main-abc123.js — but NOT application.js / mainframe.js.
// The optional group requires a `.` or `-` separator after "app" or "main".
const DEFAULT_APP_MAIN_PATTERN = /\/(app|main)([.\-][^/]+)?\.js$/i;

export function observeAppScript(options: AppMainScriptLoadOptions = {}): void {
  observeNamedScript(options, {
    defaultPattern: DEFAULT_APP_MAIN_PATTERN,
    hasStored: (ns) => ns.appMainScriptResourceResponseEnd != null,
    store: (ns, chunk) => {
      ns.appMainScriptResourceUrl = chunk.url;
      ns.appMainScriptResourceStartTime = chunk.startTime;
      ns.appMainScriptResourceResponseEnd = chunk.responseEnd;
    },
  });
}
